import React from 'react';
import { useNavigate } from 'react-router-dom';

function Datenschutzerklärung() {
    const navigate = useNavigate();

    return (
        <div className="home-page">
            <section className="hero-section py-12">
                <div className="container mx-auto px-4">
                    <h1>Datenschutzerklärung</h1>
                    <p className="lead">
                        Transparente Informationen über den Umgang mit Ihren persönlichen Daten auf unserer Plattform.
                    </p>
                </div>
            </section>

            <section className="page-content-section py-8">
                <div className="container mx-auto px-4">
                    <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden">
                        <div className="p-8">
                            <div className="prose max-w-none">
                                <p className="text-gray-700 mb-6 text-lg">
                                    Diese Datenschutzerklärung informiert Sie darüber, wie personenbezogene Daten auf dieser Website verarbeitet werden.
                                </p>
                                
                                <div className="space-y-8">
                                    <div className="bg-blue-50 rounded-lg p-6">
                                        <h2 className="text-2xl font-semibold text-gray-900 mb-4 flex items-center">
                                            <span className="text-blue-600 mr-3">👤</span>
                                            1. Verantwortlicher
                                        </h2>
                                        <div className="bg-white rounded-lg p-4">
                                            <p className="text-gray-700 mb-2"><strong>Jason Bichsel</strong></p>
                                            <p className="text-gray-700 mb-2">Schweiz</p>
                                            <p className="text-gray-700">
                                                E-Mail: <a href="mailto:Bichsel6343@outlook.com" className="text-blue-600 hover:underline font-medium">Bichsel6343@outlook.com</a>
                                            </p>
                                        </div>
                                    </div>

                                    <div className="bg-green-50 rounded-lg p-6">
                                        <h2 className="text-2xl font-semibold text-gray-900 mb-4 flex items-center">
                                            <span className="text-green-600 mr-3">📊</span>
                                            2. Erhobene Daten
                                        </h2>
                                        <div className="bg-white rounded-lg p-4">
                                            <p className="text-gray-700 mb-4">
                                                Wenn Sie sich über das Firmen-Registrierungsformular anmelden, erfassen wir folgende Angaben:
                                            </p>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <ul className="space-y-2">
                                                    <li className="flex items-center text-gray-700">
                                                        <span className="text-green-500 mr-2">✓</span>
                                                        Firmenname
                                                    </li>
                                                    <li className="flex items-center text-gray-700">
                                                        <span className="text-green-500 mr-2">✓</span>
                                                        Adresse
                                                    </li>
                                                    <li className="flex items-center text-gray-700">
                                                        <span className="text-green-500 mr-2">✓</span>
                                                        Kontaktperson
                                                    </li>
                                                </ul>
                                                <ul className="space-y-2">
                                                    <li className="flex items-center text-gray-700">
                                                        <span className="text-green-500 mr-2">✓</span>
                                                        E-Mail-Adresse
                                                    </li>
                                                    <li className="flex items-center text-gray-700">
                                                        <span className="text-green-500 mr-2">✓</span>
                                                        Telefonnummer
                                                    </li>
                                                    <li className="flex items-center text-gray-700">
                                                        <span className="text-green-500 mr-2">✓</span>
                                                        Passwort (verschlüsselt gespeichert)
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="bg-yellow-50 rounded-lg p-6">
                                        <h2 className="text-2xl font-semibold text-gray-900 mb-4 flex items-center">
                                            <span className="text-yellow-600 mr-3">🎯</span>
                                            3. Zweck und Rechtsgrundlage
                                        </h2>
                                        <div className="bg-white rounded-lg p-4 space-y-4">
                                            <p className="text-gray-700">
                                                Die Daten werden verwendet, um Ihre Firma als potenziellen Empfänger einer Bewerbung aufzulisten. 
                                                Die übermittelten Daten (außer Passwort) werden in einer öffentlich zugänglichen Firmenliste dargestellt.
                                            </p>
                                            <div className="bg-yellow-100 border-l-4 border-yellow-500 p-4">
                                                <p className="text-gray-700">
                                                    <strong>Rechtsgrundlage:</strong> Die Verarbeitung Ihrer Daten erfolgt auf Grundlage Ihrer ausdrücklichen Einwilligung gemäß Art. 6 Abs. 6 revDSG.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="bg-purple-50 rounded-lg p-6">
                                        <h2 className="text-2xl font-semibold text-gray-900 mb-4 flex items-center">
                                            <span className="text-purple-600 mr-3">🔄</span>
                                            4. Datenweitergabe
                                        </h2>
                                        <div className="bg-white rounded-lg p-4">
                                            <div className="bg-purple-100 border-l-4 border-purple-500 p-4">
                                                <p className="text-gray-700">
                                                    <strong>Wichtiger Hinweis:</strong> Die übermittelten Daten (außer Passwort) sind öffentlich einsehbar. 
                                                    Es erfolgt keine Weitergabe der Daten an Dritte außerhalb der öffentlich sichtbaren Plattform.
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="bg-red-50 rounded-lg p-6">
                                        <h2 className="text-2xl font-semibold text-gray-900 mb-4 flex items-center">
                                            <span className="text-red-600 mr-3">⏰</span>
                                            5. Speicherdauer
                                        </h2>
                                        <div className="bg-white rounded-lg p-4">
                                            <p className="text-gray-700">
                                                Die Daten werden so lange gespeichert, wie sie für den genannten Zweck erforderlich sind oder bis Sie uns zur Löschung auffordern.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="bg-indigo-50 rounded-lg p-6">
                                        <h2 className="text-2xl font-semibold text-gray-900 mb-4 flex items-center">
                                            <span className="text-indigo-600 mr-3">⚖️</span>
                                            6. Ihre Rechte
                                        </h2>
                                        <div className="bg-white rounded-lg p-4">
                                            <p className="text-gray-700 mb-4">Sie haben das Recht auf:</p>
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <ul className="space-y-2">
                                                    <li className="flex items-center text-gray-700">
                                                        <span className="text-indigo-500 mr-2">•</span>
                                                        Auskunft über Ihre gespeicherten Daten
                                                    </li>
                                                    <li className="flex items-center text-gray-700">
                                                        <span className="text-indigo-500 mr-2">•</span>
                                                        Berichtigung unrichtiger Daten
                                                    </li>
                                                    <li className="flex items-center text-gray-700">
                                                        <span className="text-indigo-500 mr-2">•</span>
                                                        Löschung Ihrer Daten
                                                    </li>
                                                </ul>
                                                <ul className="space-y-2">
                                                    <li className="flex items-center text-gray-700">
                                                        <span className="text-indigo-500 mr-2">•</span>
                                                        Einschränkung der Verarbeitung
                                                    </li>
                                                    <li className="flex items-center text-gray-700">
                                                        <span className="text-indigo-500 mr-2">•</span>
                                                        Datenübertragbarkeit
                                                    </li>
                                                    <li className="flex items-center text-gray-700">
                                                        <span className="text-indigo-500 mr-2">•</span>
                                                        Widerruf Ihrer Einwilligung
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="bg-gray-50 rounded-lg p-6">
                                        <h2 className="text-2xl font-semibold text-gray-900 mb-4 flex items-center">
                                            <span className="text-gray-600 mr-3">📧</span>
                                            7. Kontakt
                                        </h2>
                                        <div className="bg-white rounded-lg p-4">
                                            <p className="text-gray-700 mb-4">
                                                Bei Fragen zum Datenschutz wenden Sie sich bitte an:
                                            </p>
                                            <div className="bg-blue-100 rounded-lg p-4 text-center">
                                                <a href="mailto:Bichsel6343@outlook.com" className="text-blue-600 hover:text-blue-800 font-semibold text-lg">
                                                    Bichsel6343@outlook.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="mt-10 pt-6 border-t border-gray-200">
                                <div className="flex flex-col sm:flex-row gap-4">
                                    <button
                                        onClick={() => navigate('/firma/register')}
                                        className="flex-1 px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                                    >
                                        Zurück zum Registrierungsformular
                                    </button>
                                    <button
                                        onClick={() => navigate('/')}
                                        className="flex-1 px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                                    >
                                        Zur Startseite
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Datenschutzerklärung;